import { Card } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CardToolsIcons } from 'src/components/CardToolsIcons';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GenerationToolCardImage } from 'src/components/GenerationToolCardImage';
import { GENERATION_TOOL } from 'src/data/generationTool';
import { isLongFormProjectType, PROJECT_TYPE } from 'src/data/project';

import { customToolDataPropTypes } from '../../lib';
import { TemplateTag } from '../TemplateTag';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  projectType: PropTypes.oneOf(Object.values(PROJECT_TYPE)).isRequired,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)).isRequired,
  customToolData: customToolDataPropTypes,
  title: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showComingSoonTag: PropTypes.bool,
};

const defaultProps = {
  className: '',
  classes: {},
  customToolData: null,
  selected: false,
  disabled: false,
  showComingSoonTag: false,
};

export const CardLarge = ({
  className,
  classes,
  projectType,
  generationTool,
  customToolData,
  title,
  copy,
  selected,
  onClick,
  disabled,
  showComingSoonTag,
}) => {
  const styles = useStyles({ classes });

  return (
    <Card
      className={cx(styles.root, className, {
        [styles.selected]: selected,
        [styles.disabled]: disabled,
      })}
      onClick={disabled ? null : onClick}
      data-testid={`templateButton_${generationTool}`}
    >
      <GenerationToolCardImage
        className={styles.icon}
        projectType={projectType}
        tool={generationTool}
        svgStringImage={customToolData?.bigImage}
      />

      <div className={styles.copyWrapper}>
        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          <span>{title}</span>
        </CustomTypography>
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph14}
        >
          {copy}
        </CustomTypography>
      </div>

      <div className={styles.footer}>
        <TemplateTag
          generationTool={generationTool}
          customToolData={customToolData}
        />

        {showComingSoonTag && (
          <CustomTypography
            className={styles.comingSoonTag}
            variant={TYPOGRAPHY_VARIANT.medium14}
          >
            Coming soon!
          </CustomTypography>
        )}

        {!isLongFormProjectType(projectType) && (
          <CardToolsIcons
            className={styles.toolsIcons}
            generationTool={generationTool}
            customToolData={customToolData}
            title={title}
          />
        )}
      </div>
    </Card>
  );
};

CardLarge.displayName = 'CardLarge';
CardLarge.propTypes = propTypes;
CardLarge.defaultProps = defaultProps;
